module.exports = __webpack_public_path__ + "static/media/search-results.b09860e9.png";